import React from "react";
import {Routes, Route, useMatch} from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ClipPath from "../components/ClipPath";
import store from "../redux/store";
import {QueryClient, QueryClientProvider} from "react-query";
import {Provider} from "react-redux";
import {
    AssetPoc,
    ConnectSiemba,
    Home,
    PentestProfile,
    PentestReview,
    PentestScope,
    PentestTeam,
    Profile,
    UpdatePentest,
    OktaCallback
} from "./pages/PageListAsync";
import AdminRoutes from "./Routes/AdminRoutes";
import AlertProvider from "../components/SuccessOrFailedModal";
import MyDashboardRoutes from "./Routes/MyDashboardRoutes";
import TesterRoutes from "./Routes/TesterRoutes";
import moment from "moment";
import LayoutProvider from "../Providers/LayoutProvider";

// Create a client
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false
        }
    }
})

moment.updateLocale('en', {
    relativeTime : {
        future: "in %s",
        past:   "%s ago",
        s  : '1s',
        ss : '%ds',
        m:  "1m",
        mm: "%dm",
        h:  "1h",
        hh: "%dh",
        d:  "1d",
        dd: "%dd",
        M:  "1mon",
        MM: "%dmon",
        y:  "1y",
        yy: "%dy"
    }
});

function App() {

    let customLayout = false
    if (useMatch("admin/all_pentests/:pentestId/update")){
        customLayout = true
    }

    return (
        <>
        { !customLayout ? ( 
            <QueryClientProvider client={queryClient}>
            <Provider store={store}>
                <AlertProvider>
                    <Header/>
                    <ClipPath/>
                    <Routes>
                        <Route path={"/"} element={<Home/>}/>
                        <Route path={"/okta-callback"} element={<OktaCallback/>}/>
                        <Route path={"profile"} element={<Profile/>}/>
                        <Route path={"/connect_siemba"} element={<ConnectSiemba/>}/>
                        <Route path={"/pentest"}>
                            <Route path={"profile"} element={<PentestProfile/>}/>
                            <Route path={"scope"} element={<PentestScope/>}/>
                            <Route path={"team"} element={<PentestTeam/>}/>
                            <Route path={"team_overseers"} element={<PentestTeam/>}/>
                            <Route path={"team_asset_poc"} element={<AssetPoc/>}/>
                            <Route path={"review"} element={<PentestReview/>}/>
                        </Route>
                        <Route path={"/admin/*"} element={<AdminRoutes/>}/>
                        <Route path={"/app/*"} element={<MyDashboardRoutes/>}/>
                        <Route path={"/tester/*"} element={<TesterRoutes/>}/>
                    </Routes>
                    <Footer/>
                </AlertProvider>
            </Provider>
        </QueryClientProvider>) : (
            <QueryClientProvider client={queryClient}>
                <Provider store={store}>
                    <AlertProvider>
                        <ClipPath/>
                        <Routes>
                            <Route path={"/admin/all_pentests/:pentest_id/update"} element={
                                <LayoutProvider value={{
                dashboard: "ADMIN_DASHBOARD",
                mainUrl: "/admin"}}
                                ><UpdatePentest/></LayoutProvider>
                            }/>
                        </Routes>
                    </AlertProvider>
                </Provider>
            </QueryClientProvider>
        )}
        </>
       
    );
}

export default App;
